import { render, staticRenderFns } from "./certificateManagerTea.vue?vue&type=template&id=4b02a104"
import script from "./certificateManagerTea.vue?vue&type=script&lang=js"
export * from "./certificateManagerTea.vue?vue&type=script&lang=js"
import style0 from "./certificateManagerTea.vue?vue&type=style&index=0&id=4b02a104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports